import styled from "styled-components";
import { theme } from "../../../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";

export const Label = styled.div`
    font-family: ${theme.fonts.book};
    font-size: 1.3rem;
    line-height: 2rem;
    text-align: start;
    color: ${theme.colors.midnight};
`;

export const Value = styled.div`
    font-family: ${theme.fonts.bold};
    font-size: 1.3rem;
    line-height: 2rem;
    text-align: end;
    color: ${theme.colors.midnight};
`;

export const Wrapper = styled.div`
    display: flex;
    justify-content: space-between;

    & > div {
        display: flex;
        align-items: center;
    }

    ${Label} + button {
        position: relative;
        top: 1px;
        margin-left: ${theme.space[1] / 2}px;
    }

    html[dir="rtl"] & {
        ${Label} + button {
            margin-left: 0;
            margin-right: ${theme.space[1] / 2}px;
        }
    }
`;
